import { analyticService } from 'global/services';

const blocksToTrack = document.querySelectorAll('.trackableScrollBlock');

const eventsRecord = {
    romantic: 'Romantic_Scroll',
    'squid-game': 'Squid_game_Scroll',
};

const handleSendEventToAnalytics = (blockName) => {
    const { pageId } = document.body.dataset;
    analyticService.push({ eventName: eventsRecord[pageId], headerName: blockName });
};

const handleBlockIntersection = (entries) => {
    entries.forEach((entry) => {
        if (entry.isIntersecting) {
            const blockName = entry?.target?.dataset?.header_name;
            handleSendEventToAnalytics(blockName);
        }
    });
};

export const initPromoCheckoutAnalyticObserver = () => {
    if (!blocksToTrack) return;
    const observer = new IntersectionObserver(handleBlockIntersection);
    blocksToTrack?.forEach((block) => {
        observer.observe(block);
    });
};
